import dayjs, { Dayjs } from "dayjs";

/**
 * The chart date-range filter options.
 *
 * `id` is the identity and `labelKey` is what the reader sees (EN-5191). The two were the same
 * string until the portal was internationalised, which made the rendered button text load-bearing:
 * it is compared in ~25 places (`dateInterval.id === DATE_FILTER_ALL` gates axis fitting,
 * unbounded fetches and the monthly-average subtitle) and it is what
 * `userService.updateDateRangeFilter` persists as the user's preference.
 *
 * The `id` values are deliberately the old label strings, so preferences already stored
 * server-side keep resolving after this split.
 */
export const DATE_FILTER_ALL = "ALL";
export const DATE_FILTER_48H = "48H";
/** The ad-hoc range chosen in the calendar; it has no entry in the lists below. */
export const DATE_FILTER_CUSTOM = "custom";

export type DateFilterOption = {
  id: string;
  labelKey: string;
  value: (currentDate: Dayjs) => Dayjs;
};

export const dateFilterOptions: DateFilterOption[] = [
  {
    id: DATE_FILTER_48H,
    labelKey: "chart_dateFilter_48h",
    value: (currentDate: Dayjs) => currentDate.subtract(2, "day"),
  },
  {
    id: "7D",
    labelKey: "chart_dateFilter_7d",
    value: (currentDate: Dayjs) => currentDate.subtract(7, "day"),
  },
  {
    id: "1M",
    labelKey: "chart_dateFilter_1m",
    value: (currentDate: Dayjs) => currentDate.subtract(1, "month"),
  },
  {
    id: "6M",
    labelKey: "chart_dateFilter_6m",
    value: (currentDate: Dayjs) => currentDate.subtract(6, "month"),
  },
  {
    id: "12M",
    labelKey: "chart_dateFilter_12m",
    value: (currentDate: Dayjs) => currentDate.subtract(12, "month"),
  },
  {
    id: DATE_FILTER_ALL,
    labelKey: "chart_dateFilter_all",
    value: () => dayjs("1900-01-01T00:00:00Z"),
  },
];

export const dateFilterOptionsMobile: DateFilterOption[] = [
  {
    id: "24H",
    labelKey: "chart_dateFilter_24h",
    value: (currentDate: Dayjs) => currentDate.subtract(1, "day"),
  },
  {
    id: DATE_FILTER_48H,
    labelKey: "chart_dateFilter_48h",
    value: (currentDate: Dayjs) => currentDate.subtract(2, "day"),
  },
  {
    id: "7D",
    labelKey: "chart_dateFilter_7d",
    value: (currentDate: Dayjs) => currentDate.subtract(7, "day"),
  },
  {
    id: "1M",
    labelKey: "chart_dateFilter_1m",
    value: (currentDate: Dayjs) => currentDate.subtract(1, "month"),
  },
];
